import { http } from 'services/http';
import { CLIENT_INSURANCE, CLIENT_INSURANCE_HISTORY } from 'api/query-keys';
import { useMutationBase } from 'shared/hooks/use-mutation-base';

export const useDeleteClientInsurance = (clientId: number, insuranceId: number) => {
  return useMutationBase<void>({
    mutationFn: async () => {
      await http.delete(`/v1/clients/${clientId}/insurance/${insuranceId}`);
    },
    invalidateCallback: () => [
      [CLIENT_INSURANCE, clientId],
      [CLIENT_INSURANCE_HISTORY, clientId],
    ],
  });
};
